import styles from "./hotSpot.module.scss";
import PropTypes from "prop-types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const HotSpot = ({ dataPoints = [], imgUrl = "" }) => {
  return (
    <div className={`${styles["hot-spot"]}`}>
      {dataPoints.map((point, index) => (
        <OverlayTrigger
          key={index}
          placement={point.tip.placement}
          overlay={
            <Tooltip
              id={`tooltip-${index}`}
              bsPrefix={`${styles.tooltip} ${
                styles["tooltip--" + point.tip.placement]
              }`}
            >
              <div className={styles["tooltip__container"]}>
                <div
                  className={`${styles["tooltip__arrow"]} ${
                    styles["tooltip__arrow--" + point.tip.placement]
                  }`}
                ></div>
                <div className={styles["tooltip__heading"]}>
                  {point.tip.heading}
                </div>
                <div className={styles["tooltip__description"]}>
                  {point.tip.description}
                </div>
              </div>
            </Tooltip>
          }
        >
          <div
            key={index}
            className={`${styles["hot-spot__point"]} ${styles.lightbox}`}
            style={{ top: `${point.top}%`, left: `${point.left}%` }}
          ></div>
        </OverlayTrigger>
      ))}
      <img src={imgUrl} className={styles["hot-spot__images"]} />
    </div>
  );
};

HotSpot.propTypes = {
  dataPoints: PropTypes.array,
  imgUrl: PropTypes.string
};

export default HotSpot;
